module.exports = __webpack_public_path__ + "media/images/icon/3-a9af0b548f52a848efb6fd0df745dd7e.svg";